import { Component, TemplateRef } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { CcpcService } from '@app/shared/ccpc/ccpc.service';
import { CcpcPerson } from '@codecraft-works/data-models/lib/ccpc/ccpcPerson.model';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-coach-edit-button-cell',
  templateUrl: './coach-edit-button-cell.component.html',
  styleUrls: ['./coach-edit-button-cell.component.css'],
})
export class CoachEditButtonCellComponent implements AgRendererComponent {
  coach: CcpcPerson;
  faEdit = faEdit;
  modalRef: BsModalRef;

  coachForm: FormGroup;
  coachName: FormControl;
  coachOrganization: FormControl;
  coachEmail: FormControl;

  constructor(
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private ccpcService: CcpcService
  ) {}
  refresh(params: ICellRendererParams): boolean {
    this.coach = params.data;
    return true;
  }
  agInit(params: ICellRendererParams): void {
    this.coach = params.data;
    this.coachName = new FormControl(null, [Validators.required]);
    this.coachEmail = new FormControl(null, [
      Validators.required,
      Validators.email,
    ]);
    this.coachOrganization = new FormControl(null);
    this.coachForm = this.formBuilder.group({
      name: this.coachName,
      organization: this.coachOrganization,
      email: this.coachEmail,
    });

    this.coachForm.patchValue(this.coach);
  }

  /**
   * Handles opening modal
   * @param modalTemplate
   */
  openModal(modalTemplate: TemplateRef<any>) {
    this.modalRef = this.modalService.show(modalTemplate, {
      class: 'modal-lg modal-dialog modal-dialog-centered',
    });
  }

  async editCoach() {
    if (this.coachForm.get('name').touched) {
      this.coach.name = this.coachForm.get('name').value;
    }
    if (this.coachForm.get('organization').touched) {
      this.coach.organization = this.coachForm.get('organization').value;
    }
    if (this.coachForm.get('email').touched) {
      this.coach.email = this.coachForm.get('email').value;
    }
    await this.ccpcService.updateCoach(
      this.coach.competitionId,
      this.coach.tournamentId,
      this.coach
    );
  }
}
